import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return 'Nå nettopp';
  if (minutes < 60) return `${minutes}m siden`;
  if (hours < 24) return `${hours}t siden`;
  if (days < 7) return `${days}d siden`;
  
  return date.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short' });
}
